module.exports = __webpack_public_path__ + "static/media/offset-booklet-icon-177x197.9c960689.jpg";